const iconNames = {
  ADD: 'add',
  EXPORT: 'export',
  GEAR: 'gear',
  DOWN_ARROW: 'down-arrow',
  LEFT_ARROW: 'left-arrow'
};

export default iconNames;